import { ref, computed, watch } from 'vue'
import { defineStore } from 'pinia'


/*
  initial -> (app mounted) waitingWorker ->
    (no answer from worker) workerBroken
    (worker answered) waitingAuthCheck ->
      (token is fresh of refreshed) loadingReferences -> (codes and profile loaded) ready
      (no token or refresh failed) notAuthorized
 */
export enum TabInitStatus {
  initial = 'initial',
  waitingWorker = 'waitingWorker',
  waitingAuthCheck = 'waitingAuthCheck',
  workerBroken = 'workerBroken', // final
  notAuthorized = 'notAuthorized', // final
  loadingReferences = 'loadingReferences',
  ready = 'ready', // final
}

export const useInitStore = defineStore('init', () => {

  const status = ref(TabInitStatus.initial)

  const isLoading = computed(() =>
    ![
      TabInitStatus.ready,
      TabInitStatus.notAuthorized,
    ].includes(status.value),
  )

  const isAuthRequired = computed(() =>
    [TabInitStatus.notAuthorized].includes(status.value),
  )

  function setState(newState: TabInitStatus) {
    status.value = newState
  }

  watch(status, () => {
    console.log('⦿', status.value)
  })

  return {
    status,
    isLoading,
    isAuthRequired,
    setState,
  }
})
